export default __webpack_public_path__ + "static/images/09c69d0345a001da8f6f92ed3fb32177.png";